declare namespace $ {

	type $mol_string__value_shm_hitalama_map_widget_float_customizer_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_customizer['title'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_check_box__title_shm_hitalama_map_widget_float_customizer_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_hitalama_map_widget_float_customizer_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_customizer['visible_in_menu'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_button_major__title_shm_hitalama_map_widget_float_customizer_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_shm_hitalama_map_widget_float_customizer_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_customizer['create_instance'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_customizer_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__sub_shm_hitalama_map_widget_float_customizer_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['sub'] >
	>
	type $mol_textarea__title_shm_hitalama_map_widget_float_customizer_8 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_textarea['title'] >
	>
	type $mol_textarea__sidebar_showed_shm_hitalama_map_widget_float_customizer_9 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_textarea['sidebar_showed'] >
	>
	type $mol_textarea__value_shm_hitalama_map_widget_float_customizer_10 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_customizer['code_view_tree'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_textarea__title_shm_hitalama_map_widget_float_customizer_11 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_textarea['title'] >
	>
	type $mol_textarea__sidebar_showed_shm_hitalama_map_widget_float_customizer_12 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_textarea['sidebar_showed'] >
	>
	type $mol_textarea__value_shm_hitalama_map_widget_float_customizer_13 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_customizer['code_css'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_textarea__title_shm_hitalama_map_widget_float_customizer_14 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_textarea['title'] >
	>
	type $mol_textarea__sidebar_showed_shm_hitalama_map_widget_float_customizer_15 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_textarea['sidebar_showed'] >
	>
	type $mol_textarea__value_shm_hitalama_map_widget_float_customizer_16 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_customizer['code_js'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_deck__current_shm_hitalama_map_widget_float_customizer_17 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_customizer['soure_type_current'] >
		,
		ReturnType< $mol_deck['current'] >
	>
	type $mol_deck__items_shm_hitalama_map_widget_float_customizer_18 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_deck['items'] >
	>
	export class $shm_hitalama_map_widget_float_customizer extends $shm_hitalama_map_widget_float {
		title( next?: string ): string
		Name( ): $mol_string
		visible_in_menu( next?: boolean ): boolean
		Visible( ): $mol_check_box
		create_instance( next?: any ): any
		Create( ): $mol_button_major
		Head( ): $mol_view
		Controls( ): $mol_list
		Deck_switch( ): ReturnType< ReturnType< $shm_hitalama_map_widget_float_customizer['Deck'] >['Switch'] >
		Deck_content( ): ReturnType< ReturnType< $shm_hitalama_map_widget_float_customizer['Deck'] >['Content'] >
		soure_type_current( next?: string ): string
		code_view_tree( next?: string ): string
		View_tree( ): $mol_textarea
		code_css( next?: string ): string
		Css( ): $mol_textarea
		code_js( next?: string ): string
		Js( ): $mol_textarea
		controls( ): readonly(any)[]
		Deck( ): $mol_deck
		attr( ): ({ 
			'mol_theme': string,
		})  & ReturnType< $shm_hitalama_map_widget_float['attr'] >
	}
	
}

//# sourceMappingURL=customizer.view.tree.d.ts.map